import { type AbstractChatClient } from 'shared/clients/abstractChatClient';
import { type BaseChatService } from 'shared/services/baseChatService';
import { MessageEventService } from 'shared/services/messageEventService';
import { handleAsync } from 'utils/errorHandler';

// Adds a message listener to the specified iframe
export const initializeiFrameListener = (
  service: BaseChatService<AbstractChatClient>,
): void => {
  const messageEventService = MessageEventService.getInstance();

  messageEventService.subscribe((event) => {
    if (event?.type !== 'initiateChat') return;
    const { payload } = event;

    handleAsync(() => service.initiateChat(payload));
  });
};
